export function isValidUsOrCanadaZip(zip: string) {
    
    var afterCom = window.location.href.split('.com')[1];
    var isWebSite = afterCom.split('/')[1].replace(/[^a-zA-Z ]/g, "") === "ca" ? "ca" : "us";
   
    if (isWebSite == "ca")
        return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(zip)
     else if (isWebSite == "us")      
         return /^(\d{5}(-\d{4})?|[A-Z]\d[A-Z] ?\d[A-Z]\d)$/.test(zip)
}